import React,{useState} from 'react';
import AircraftTypes from '../Form/AircraftTypes';
import CharterType from '../Form/CharterType';
import ClientSelector from '../Form/ClientSelector';
import DangerousGoods from '../Form/DangerousGoods'
import BooleanInput from '../Form/BooleanInput';
import FormInput from '../Form/FormInput';
import FlightRoute from './FlightRoute';
import { Row, Col,Button } from 'reactstrap';
import ClientDetailsCard from '../Cards/ClientDetailsCard'
import { useFormikContext } from 'formik';
import { endpoints } from '../../utils/Constants';
import Inexclusions from "../Form/Inexclusions";
import { useAuth } from '../../Services/AuthContext';
import SelectSetting from '../Form/SelectSetting';
import useCheckMobileScreen from '../../utils/Hooks/useCheckMobileScreen';
import { useFetchCached } from '../../Services/fetchApi';
import LoadingAnimation from '../Form/LoadingAnimation';
import { useEdit } from '../../Services/EditContext';
import RoutesSummary from './RoutesSummary';
import FlightTimeSummary from './FlightTimeSummary';
import Modal from '../Models/Modal';
import EditorTitle from '../Models/EditorTitle';
import entities from '../../utils/entities';
import useFunction from '../../utils/Hooks/useFunction';
import FormContainer from '../Models/FormContainer';
import Manifest from './Manifest';
import  FormTextArea  from '../Form/FormTextArea';

const CloneCharterRequestDetail = (props) => {
    const { newRequest, compare, noEdit, route } = { ...props };
    const [auth] = useAuth();
    const {setFieldValue, values } = useFormikContext();   
    const clientChange = compare && (!values.supplierInitiated && values.status !== "Pending Supplier");
    const isMobile = useCheckMobileScreen();    
    const [edit] = useEdit();
    
    const [charterTypes, loadingCharterTypes, errorCharter] = useFetchCached(endpoints.getCharterType);
    const placeBid = values.bid ? true : false;
    const [editManifest, setEditManifest] = useState(false);
    const [handleSubmit, setHandleSubmit] = useFunction()
    const [isSubmitting, setSubmit] = useState();

    const NewActions = () => {
        const handleClick = () => {
            handleSubmit();
        }
        return isSubmitting ? null : <Button onClick={handleClick}>Save</Button>
    }

    const saveManifest = (newValues) => {
        const routes = newValues.routes;
        const shareManifest = newValues.shareManifest;
        const newRoutes = routes?.map(x => {
            const manifest = shareManifest ? routes[0].manifest : x.manifest;
            if (manifest && manifest.length) {
                x.passengerNumber = manifest.length;
                x.totalWeight = manifest.reduce((a, x) => a + (x.freightWeight ? x.freightWeight : 0) + (x.cargoWeight ? x.cargoWeight : 0) + (x.passengerWeight ? x.passengerWeight : 0), 0);
            }
            x.manifest = manifest;
            return x;
        })
        setFieldValue('routes', newRoutes);       
        setEditManifest(false);
    }

    return (<React.Fragment>
        {/* {values.changePending ? values.status === 'Superceded' ? <h6>This charter has been superceded <Button color='primary' onClick={viewChanged}>View Changed Charter</Button></h6> : <h3>There is a change pending for this record</h3> : null}
        {values.lastVersion ? <h6>This charter has changed <Button onClick={viewPrevious}>View Previous Version</Button></h6> : null} */}

        {auth.role !== 'Supplier' || values.status === 'Approved' ? <ClientDetailsCard route={route} charterDetails={values} /> : null}
        {/* {!clientChange && !supplierChange && (placeBid || values.bidderId) ? <SupplierSelector route={route} id='bidderId' name='bidderId' /> : <SupplierDetail route={route} supplier={values.supplier} />} */}
        {!clientChange && newRequest ? <ClientSelector all route={route} id='clientId' name='clientId' noEdit={noEdit} /> : <ClientDetailsCard route={route} />}
        {values.changePending ? <h5>There is a change pending for this charter request.</h5> : null}
        <Row>
            <Col>
                <AircraftTypes compare={compare} id='preferredAircraft' label='Preferred Aircraft' list={charterTypes?.aircraftTypes} noEdit={noEdit} />
            </Col>          

        </Row>
        {!newRequest && (values.specialRequests || clientChange) ? <FormTextArea id='specialRequests' label='Special Requests' type='textarea' noEdit={!clientChange && (noEdit || placeBid)} /> : null}
        <CharterType placeBid={placeBid} compare={compare} charterTypes={charterTypes} noEdit={noEdit} />
        {values.status === "Confirmed" || values.status === "Finished" ? <FlightTimeSummary /> : null}
        {auth.role === "Admin" && values.routes instanceof Array ? <RoutesSummary /> : null}
        {loadingCharterTypes ? <LoadingAnimation height={50} /> : null}
        {errorCharter ? <h6>Error Loading Charter Types</h6> : null}

        <FlightRoute noEdit={noEdit} placeBid={placeBid} newRequest={newRequest} compare={compare} showEditManifest={editManifest} />

        <Row>
            {newRequest || values?.status === "Live" || values?.status === "Pending" ? <Col md='4' xs='4'>
                {(edit && !noEdit) || newRequest || values?.urgent ? <BooleanInput style={!newRequest && !edit && !noEdit ? { color: 'red' } : {}} id='urgent' label='Urgent - within 24 hours' noEdit={noEdit} /> : null}
            </Col> : null}
            {newRequest ? <Col md='4' xs='4'>
                <FormInput id='biddingTimeSpanHours' label='Bidding To Close in: (Hours)' type='number' noEdit={noEdit} suffix='hrs' />
            </Col> : null}

        </Row>
        <Row>
            <Col>
                {newRequest ? <FormTextArea id='specialRequests' label='Special Requests' type='textarea' /> : null}
            </Col>
        </Row>
        {/* {values.status === "Confirmed" || values.status === "Closed" ? <>styff</> : null} */}
        {placeBid ? <React.Fragment>

            {/* {placeBid || values.notes ? <FormInput compare={compare} id='notes' label='Notes for customer' type='textarea' noEdit={clientChange} /> : null} */}

            {!isMobile ? <Row>
                <Col md='3' xs='6'>
                    <SelectSetting endpoint={endpoints.getSettings + 'Catering'} id='catering' label='Catering' />
                </Col>
                <Col md='3' xs='6'>
                    <Inexclusions noEdit={clientChange} />
                </Col>
                {/* <Col md='3' xs='6'>
                    <SelectCurrency id='currency' label='Currency' noEdit={clientChange} />
                </Col>
                <Col md='3' xs='6'>
                    <Col >
                        <FormInput id='price' label='Price (EX GST)1' type='number' noEdit={clientChange} />
                    </Col>
                    {auth.role === 'Admin' && values.withMargin ? <Col>
                        <FormGroup><FormLabel style={{ display: 'block' }}>{'With Margin'}</FormLabel>
                            <ErrorMessage name={'withMargin'} />
                            <CompareFormValue id='withMargin' type='currency' style={{ display: 'block' }} />

                        </FormGroup>
                    </Col> : null}
                </Col> */}

            </Row> : <React.Fragment><Row>
                <Col md='3' xs='6'>
                    <SelectSetting endpoint={endpoints.getSettings + 'Catering'} id='catering' label='Catering' />
                </Col>
                <Col md='3' xs='6'>
                    <Inexclusions noEdit={clientChange} />
                </Col>
            </Row>
            {/* <Row>
                    <Col md='3' xs='6'>
                        <SelectCurrency id='currency' label='Currency12' noEdit={clientChange} />
                    </Col>
                    <Col md='3' xs='6'>
                        <Col >
                            <FormInput id='price' label='Price (EX GST)122' type='number' noEdit={clientChange} />
                        </Col>
                        {auth.role === 'Admin' && values.withMargin ? <Col>
                            <FormGroup><FormLabel style={{ display: 'block' }}>With Margin</FormLabel>
                                <ErrorMessage name={'withMargin'} />
                                <CompareFormValue id='withMargin' type='currency' style={{ display: 'block' }} />

                            </FormGroup>
                        </Col> : null}
                    </Col>


                </Row> */}
            </React.Fragment>}

        </React.Fragment> : null}
        <DangerousGoods compare={compare} dangerousGoodsList={charterTypes?.dangerousGoods} noEdit={noEdit} />
        {/* {values.biddingEndsAt ? < div style={{ fontSize: 'small' }}>Bidding Ends At:{showDateTimeUTC(values.biddingEndsAt)}</div> : null} */}
        <Row>
            <Col></Col>
            <Col></Col>
            <Col>
            <Modal open={!!editManifest} onClose={() => setEditManifest(false)} title={<EditorTitle entity={entities.manifest} detail={values} />} actions={<NewActions />}  >
            <FormContainer initialValues={{ ...values }} validationSchema={entities.manifest.validationSchema} edit={edit} setHandleSubmit={setHandleSubmit} onSubmit={saveManifest} setSubmitting={setSubmit}>
                <Manifest newRequest />
            </FormContainer >
             </Modal>
            <Button onClick={() => setEditManifest(true)} style={{ marginBottom: '15px' }}>Passengers</Button>
            </Col>
        </Row>
    </React.Fragment>)
};

export default CloneCharterRequestDetail;